module.exports = __webpack_public_path__ + "img/memtergray.c69905d4.png";